import Breadcrumbs from '../components/Breadcrumb';
import {
    GeneralContainer,
    GeneralContainerTitle,
    GeneralContainerBody
} from "../styles/container.style";


export default function AdminContentLayout({ title, PathList, children }) {
    return (
        <>
            <Breadcrumbs pathList={PathList} />
            <GeneralContainer>
                <GeneralContainerTitle>OBU {title}</GeneralContainerTitle>
                <GeneralContainerBody>
                    {children}
                </GeneralContainerBody>
            </GeneralContainer>
        </>
    )
}